export default {
  header: {
    title: 'Usar tus puntos',
    balance: '{{value}} pts disponibles',
  },
  option_label: '{{value}} pts',
  buttons: {
    none: 'Ninguno',
  },
  toasts: {
    enabled: 'Puntos de fidelidad aplicados correctamente',
    removed: 'Puntos de fidelidad eliminados',
  },
};
